import React from "react";
import { Info, AlertTriangle } from "lucide-react";

const SEVERITY_STYLES = {
  attention: {
    bg: "#FEF3CD",
    border: "#F5E6A3",
    icon: "#8A6D1B",
    title: "#65541B",
    text: "#7B6520",
    Icon: AlertTriangle,
  },
  info: {
    bg: "#EAFAF6",
    border: "#B0FCEA",
    icon: "#00664C",
    title: "#003326",
    text: "#008572",
    Icon: Info,
  },
};

export default function SpecialSituations({ situations }) {
  if (!situations || !situations.length) return null;

  return (
    <div className="space-y-3">
      {situations.map((sit) => {
        const style = SEVERITY_STYLES[sit.severity] || SEVERITY_STYLES.info;
        const { Icon } = style;

        return (
          <div
            key={sit.key}
            className="rounded-2xl px-5 py-4"
            style={{ background: style.bg, border: `1px solid ${style.border}` }}
          >
            <div className="flex items-start gap-3">
              <div
                className="w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5"
                style={{ background: `${style.icon}15` }}
              >
                <Icon className="w-3.5 h-3.5" style={{ color: style.icon }} />
              </div>
              <div className="flex-1 min-w-0">
                <h4
                  className="text-sm font-semibold mb-1"
                  style={{ fontFamily: "Poppins, sans-serif", color: style.title }}
                >
                  {sit.title}
                </h4>
                <p
                  className="text-xs leading-[1.65]"
                  style={{ fontFamily: "Work Sans, sans-serif", color: style.text }}
                >
                  {sit.description}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
